import {createAction, props} from '@ngrx/store';
import {BelegZahlungsartDTO} from '../../openapi/beleg-openapi';

export class EditActions {
  static readonly prefix = '[Edit] ';

  public static openEdit = createAction(
    this.prefix + 'Opens the edit route.',
    props<{
      inhaberId: string;
      belegId: string;
      belegIds: string[];
    }>(),
  );

  public static openEditSuccess = createAction(
    this.prefix + 'Opens the edit route successfully.',
    props<{
      belegIds: string[];
    }>(),
  );

  public static setCurrentBelegId = createAction(
    this.prefix + 'Sets the current belegId.',
    props<{
      belegId: string;
    }>(),
  );

  public static previousBeleg = createAction(this.prefix + 'Navigate to the previous beleg.');

  public static nextBeleg = createAction(this.prefix + 'Navigate to the next beleg.');

  public static firstBeleg = createAction(this.prefix + 'Navigate to the first beleg.');

  public static lastBeleg = createAction(this.prefix + 'Navigate to the last beleg.');

  public static setCurrentBelegByNumber = createAction(
    this.prefix + 'Sets the current beleg by its number in the list.',
    props<{
      belegNumber: number;
    }>(),
  );

  public static changedFormFieldEingangAusgang = createAction(
    this.prefix + 'Changed the form field eingang/ausgang.',
    props<{
      belegeingang: boolean;
    }>(),
  );

  public static changedFormFieldDatum = createAction(
    this.prefix + 'Changed the form field datum.',
    props<{
      datum?: string;
    }>(),
  );

  public static changedFormFieldVorgangsartId = createAction(
    this.prefix + 'Changed the form field vorgangsart.',
    props<{
      vorgangsartId?: string;
    }>(),
  );

  public static changedFormFieldMitarbeiterIds = createAction(
    this.prefix + 'Changed the form field mitarbeiter.',
    props<{
      mitarbeiterIds: string[];
    }>(),
  );

  public static addedFormFieldMitarbeiterId = createAction(
    this.prefix + 'Added a mitarbeiter to the form field mitarbeiter.',
    props<{
      mitarbeiterId: string;
    }>(),
  );

  public static changedFormFieldPartnerbezeichnung = createAction(
    this.prefix + 'Changed the form field partnerbezeichnung.',
    props<{
      partnerbezeichnung?: string;
    }>(),
  );

  public static changedFormFieldBetrag = createAction(
    this.prefix + 'Changed the form field betrag.',
    props<{
      betrag?: number;
    }>(),
  );

  public static changedFormFieldDauerbeleg = createAction(
    this.prefix + 'Changed the form field dauerbeleg.',
    props<{
      dauerbeleg?: boolean;
    }>(),
  );

  public static changedFormFieldKommentar = createAction(
    this.prefix + 'Changed the form field kommentar.',
    props<{
      kommentar?: string;
    }>(),
  );

  public static changedFormFieldZahlungsart = createAction(
    this.prefix + 'Changed the form field zahlungsart.',
    props<{
      zahlungsart?: BelegZahlungsartDTO;
    }>(),
  );

  public static updateFormBlockValidityBeleg = createAction(
    this.prefix + 'Update form-block validity for beleg.',
    props<{
      valid: boolean;
    }>(),
  );

  public static openOverviewPage = createAction(this.prefix + 'Opens the overview page.');

  public static openOverviewPageSuccess = createAction(this.prefix + 'Opens the overview page successfully.');
}
